<template>
  <v-layout column>
    <v-flex xs12 md12 style="overflow: hidden;">
      <v-toolbar color="white" flat v-if="!searchlistbot">
        <v-btn icon light @click="backToFriendList()">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text text--darken-4 CSChatThai">รายการบอท</v-toolbar-title>
        <v-spacer></v-spacer>
          <v-btn icon light @click="searchlistbot = !searchlistbot">
            <v-icon color="grey darken-2">search</v-icon>
          </v-btn>
      </v-toolbar>
      <v-toolbar color="white" flat v-else>
          <v-text-field
            v-model="search"
            label="ค้นหาบอท"
            single-line
            clearable
            solo
            style="margin-top: 2vh;"
            class="CSChatThai"
            append-icon="search"
          ></v-text-field>
          <v-btn icon light @click="searchlistbot = !searchlistbot">
          <v-icon color="grey darken-2">clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container grid-list-md  v-if="progress">
        <v-layout column wrap justify-center align-center style="height: 70vh;">
          <v-progress-circular :size="60" :indeterminate="progress" color="primary"></v-progress-circular>
        </v-layout>
      </v-container>
      <v-container grid-list-md style="overflow-y: scroll; max-height: 70vh;" v-else>
        <v-layout wrap>
          <v-flex xs12 sm12 v-if="FilterBotList.length != 0">
            <v-list two-line v-for="(item, index) in FilterBotList" v-if="FilterBotList.length != 0" :key="index" avatar >
              <v-list-tile @click="routeProfile(item)">
                <v-list-tile-avatar>
                  <img v-if="item.profilepicture != ''" :src="item.profilepicture" class="alligator-turtle">
                  <v-img v-else src='../../static/img/robot/robot1.png' class="alligator-turtle"/>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.nickname"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.status"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </v-list>
          </v-flex>
          <v-flex xs12 md12 style="justify-content: center; display: flex;" v-else>
            <v-layout align-center justify-center column>
            <h3 class="CSChatThai" style="margin-top: 5vh;">ไม่มีรายการบอท</h3>
              <v-btn class="buttoneditmo" flat @click="tocreate()" style="margin-top: 2vh;">
                <v-icon style="color: rgb(74, 74, 74);  font-size: 18px !important;" >add_circle</v-icon>
                  สร้างบอท
              </v-btn>
          </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'

Vue.component(VueQrcode.name, VueQrcode)
export default {
  data: () => ({
    searchlistbot: false,
    text: 'Lorem ipsum dolor sit am',
    development: '',
    phone: '',
    email: '',
    token: '',
    name: '',
    status: '',
    TypeSearch: '',
    search: '',
    NewArray: [], // เอาไว้รับค่าที่ socket ส่งมาเพื่อเก็บไว้
    ArrayList: [], // เอาไว้เก็บข้อมูลเพื่อทำการ push เก็บรอการส่งเข้า global variable
    tokenFriend: '',
    filename: '',
    webbackend: '',
    buttonRadio: [
      {label: 'Email', color: 'green', value: 'email'},
      {label: 'Botname', color: 'blue', value: 'botname'},
      {label: 'Phone', color: 'yellow', value: 'phone'}
    ],
    tokenedit: '',
    developmentedit: '',
    nameedit: '',
    statusedit: '',
    phoneedit: '',
    edit: false,
    editname: false,
    editdescription: false,
    returnresponse: '',
    tokenservice: '',
    tokenserviceedit: '',
    tokenuserQR: '',
    hideAuthen: false,
    active: null,
    menu1: 'select_Menu',
    menu2: 'nonselect_Menu',
    listbots: [],
    friendRead: 0,
    windowWidth: '',
    progress: false
  }),
  methods: {
    getlistbot () {
      this.progress = true
      this.$http.post(process.env.APImanage + '/web/getlistbot', {tokenuser: this.token}).then((response) => {
        // console.log(response.body)
        if (response.body['message'] === 'success') {
          this.progress = false
          this.listbots = response.body['listbot']
          this.routeProfile(this.listbots[this.findWithAttr(this.listbots, 'bot_id', localStorage.getItem('room'))])
        }
      })
    },
    tocreate () {
      this.$router.push('/mobile/dev_createbot')
    },
    gotoLink (link) {
      if (link === 'logout') {
        this.logout()
      } else {
        this.$router.push(link)
      }
    },
    backToFriendList () {
      this.$emit('data', true)
      this.$router.push('/mobile/develop/homepage')
      this.$store.dispatch('tokenRoom', 'noneselect')
      this.$store.dispatch('changeRightTool', 'Friend')
      this.$cookies.set('tokenRoom', 'noneselect')
      localStorage.setItem('room', 'noneselect')
      this.$store.dispatch('changeGroup', 'noneselect')
    },
    findWithAttr (array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    routeProfile (data) {
      // console.log(data)
      if (data === undefined) {
        this.$router.push('/mobile/dev_listbot')
        this.$store.dispatch('tokenRoom', 'noneselect')
        this.$store.dispatch('changeRightTool', 'Friend')
        this.$cookies.set('tokenRoom', 'noneselect')
        localStorage.setItem('room', 'noneselect')
        this.$store.dispatch('changeBot', 'noneselect')
      } else {
        this.$store.dispatch('tokenRoom', data.bot_id)
        this.$store.dispatch('changeBot', data)
        localStorage.setItem('room', data.bot_id)
        this.actionF = data.bot_id
        this.$store.dispatch('changeRightTool', 'Friend')
        this.$cookies.set('tokenRoom', data.bot_id)
        this.$router.push('/mobile/dev_manage/' + data.bot_id)
        this.$emit('data', true)
      }
    },
    selectmenu (menu) {
      // console.log(menu)
      if (menu === 1) {
        this.active = 'tab-1'
        this.menu1 = 'select_Menu'
        this.menu2 = 'nonselect_Menu'
      } else if (menu === 2) {
        this.active = 'tab-2'
        this.menu1 = 'nonselect_Menu'
        this.menu2 = 'select_Menu'
      }
    },
    updatename () {
      this.editname = !this.editname
      this.$http.post(process.env.APImanage + '/setnameuser', {tokenuser: this.token, name: this.nameedit}).then((response) => {
        // console.log(this.token)
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'name ' + this.nameedit)
          localStorage.setItem('name', this.nameedit)
          this.name = this.nameedit
        }
      }, (response) => {})
    },
    updatestatus () {
      this.editdescription = !this.editdescription
      this.$http.post(process.env.APImanage + '/setstatususer', {tokenuser: this.token, status: this.statusedit}).then((response) => {
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'status ' + this.statusedit)
          localStorage.setItem('status', this.statusedit)
          this.status = this.statusedit
        }
      }, (response) => {})
    },
    uppic () {
      // ga('send','event','Edit Profile Engagement','Click Navbar','Button=Photo')
      // $("#uploadpicprofilechat").click();
      document.getElementById('uploadpicprofilechat').click()
    },
    editprofile () {
      this.edit = !this.edit
      this.nameedit = this.name
      this.statusedit = this.status
      this.phoneedit = this.phone
      this.emailedit = this.email
      this.tokenedit = this.token
      this.tokenserviceedit = this.tokenservice
    },
    changeprofile () {
      this.edit = !this.edit
      this.$http.post(process.env.APImanage + '/setnameuser', {tokenuser: this.token, name: this.nameedit}).then((response) => {
        // console.log(this.token)
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'name ' + this.nameedit)
          localStorage.setItem('name', this.nameedit)
          this.name = this.nameedit
        }
      }, (response) => {})
      this.$http.post(process.env.APImanage + '/setstatususer', {tokenuser: this.token, status: this.statusedit}).then((response) => {
        if (response.body['status'] === 'success') {
          this.$store.dispatch('myProfile', 'status ' + this.statusedit)
          localStorage.setItem('status', this.statusedit)
          this.status = this.statusedit
        }
      }, (response) => {})
    },
    previewImageprofiles (data) {
      // console.log('previewImageprofile')
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      // console.log(this.selectFile)
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenuser', localStorage.getItem('tokenuser'))
      this.$http.post(process.env.APImanage + '/setpictureprofileuser', uploadFile).then((response) => {
        // console.log(response.body)
        if (response.body['status'] === 'success') {
          // console.log('response.body')
          this.filename = response.body.filename
          this.returnresponse = response.body
          this.$store.dispatch('myProfile', response.body.filename)
          localStorage.setItem('profilepicture', response.body.filename)
        }
      }, (response) => {})
    }
  },
  computed: {
    FilterBotList () {
      if (this.search !== '' && this.search !== null) {
        return this.listbots.filter(post => {
          // console.log(this.search)
          return post.nickname.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listbots
      }
    },
    ...mapState({
      myprofile: 'myprofile',
      listbot: 'listbot'
    })
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    windowWidth () {
      if (this.windowWidth > 960) {
        this.$router.push('/develop/homepage')
      }
    },
    myprofile () {
      // console.log('myProfile')
      this.filename = localStorage.getItem('profilepicture')
    },
    listbot () {
      this.$http.post(process.env.APImanage + '/web/getlistbot', {tokenuser: this.token}).then((response) => {
        this.listbots = response.body['listbot']
        // console.log(this.listbots)
      })
    }
  },
  created () {
    this.phone = localStorage.getItem('phone')
    this.email = localStorage.getItem('email')
    this.token = localStorage.getItem('tokenuser')
    this.name = localStorage.getItem('name')
    this.status = localStorage.getItem('status')
    this.webbackend = process.env.API
    this.filename = localStorage.getItem('profilepicture')
    this.development = '-'
    this.tokenservice = localStorage.getItem('tokenservice')
    this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(localStorage.getItem('email'))
    this.nameedit = this.name
    this.statusedit = this.status
    this.getlistbot()
  }
}
</script>
<style type="text/css" scoped>
.buttoneditmo {
  /*border: solid 1px #DEE5EC !important;*/
  /*border: solid 1px #1976d299 !important;*/
  border-style: solid !important;
  border-radius: 1px !important;
  border-color: #1976d299 !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}
.bgsearchweb {
  background-color: #232a35 !important;
  color: white !important;
  border-radius: 100px !important;
  font-size: 12px !important;
  margin-top: 2vh !important;
  margin-bottom: 2vh !important;
}
.header {
    display: block;
    font-size: 1.17em;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    margin: 40px 0 20px;
    padding-left: 20px;
    line-height: 1.3;
    font-weight: bold;
    font-size: 16px;
    position: relative;
    color: black !important;
}
.header::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 32px;
    border-left: 4px solid #1a76d2;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.edit {
  font-weight: 100;
}
.inputWrapper {
    height: 32px;
    width: 90px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    /*margin-top: 5vh;*/
    /*Using a background color, but you can use a background image to represent a button*/
    /*background-color: #DDF;*/
}
.img {
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}
.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}
input[type=textprofile] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
input[type=textprofile]:disabled {
    background: #cac9c9;
}
.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}
.urlcopymessageapi {
  display: none !important;
}
.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}
.header {
    display: block;
    font-size: 1.17em;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    margin: 40px 0 20px;
    padding-left: 20px;
    line-height: 1.3;
    font-weight: bold;
    font-size: 16px;
    position: relative;
    color: black !important;
}
.header::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 32px;
    border-left: 4px solid #1a76d2;
}
.Setting {
    margin-bottom: 2vh;
}
.SettingBlock {
    padding: 30px 20px;
    border-top: 1px solid #DEE5EC;
}
.SettingBlock > :last-child {
    margin-bottom: 0;
}
.List_Register {
    margin-bottom: 32px;
    box-sizing: border-box;
}
.List_Register .List_item:last-child {
    border-bottom: none;
}
.List_Register .List_item {
    display: -webkit-flex;
    display: flex;
    padding: 0;
}
.List_Register .List_item:last-child .List_item_header {
    width: 200px;
}
.SettingTtl {
    margin-bottom: 8px;
    font-weight: bold;
    white-space: nowrap;
    color: black !important;
}
.md91SettingImg {
    padding-bottom: 12px;
    line-height: 1;
}
.SettingImgWrap {
    display: inline-block;
    position: relative;
    border-radius: 40px;
    overflow: hidden;
}
.SettingImgMask {
   position: relative;
    width: 160px;
    height: 160px;
    overflow: hidden;
    border-radius: 40px;
}

.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}
.SettingImgInput {
    position: absolute;
    left: -9999px;
}
.EditAreaNote {
    margin: 8px 0 0;
    font-size: 13px;
    color: #BEC8D2;
    font-size: 12px;
}
.EditArea {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}
.BreakWord {
    white-space: pre-wrap;
    word-break: break-all;
    word-break: break-word;
    word-wrap: break-word;
}
.EditAreaCont {
    width: 100%;
    padding-right: 1em;
    box-sizing: border-box;
}
.SettingQr {
    display: -webkit-flex;
    display: flex;
}
.SettingQrImg {
    margin: 0 50px;
    position: relative;
}
.SettingQrNote {
    margin-bottom: 0;
    font-size: 13px;
}
/*.buttonedit {
  border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}*/
.EditAreaContFlex {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}

.InputEdit {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
/*.avatarpicBis:hover .overlay {
  opacity: 1;

}*/
</style>



// WEBPACK FOOTER //
// src/components/mobile/ListbotMo.vue